import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id F6A782BB-5FAB-4FC4-A61B-A0F399A0A5AC
 * name image-outline
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-outline.svg
 * tags
 */
export const ImageOutlineIcon = createSvgIcon(<><path d="M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z" /></>, 'ImageOutlineIcon');
export default ImageOutlineIcon